import React from 'react'
import {Link as ReactRouterLink} from 'react-router-dom'
import {withRouter} from 'react-router'
import get from 'lodash.get'

const Link = ({children, to, location}) => {
  const pathname = get(to, 'pathname', to)
  const state = get(to, 'state', {})
  const backTo = [location.pathname, location.search].join('')

  return (
    <ReactRouterLink to={{
      pathname,
      state: {
        backTo,
        ...state,
      }
    }}>
      {children}
    </ReactRouterLink>
  )
}

export default withRouter(Link)
